import '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export function getData(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/product', { params: new_params })
}

export function getDetail(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/product/' + id, { params: new_params })
}

export function getDataCombo(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/productcombo', { params: new_params })
}

export function getDetailCombo(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/productcombo/' + id, { params: new_params })
}

export function getProductGroup(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/productgroup', { params: new_params })
}

export function setProductFavorite(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/productfavorite', data, { params: new_params })
}

export function delProductFavorite(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.delete(getBaseUrl() + '/productfavorite/' + id, { params: new_params })
}

export function getDataFavorite(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/productfavorite', { params: new_params })
}

export function checkMaterial(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/ingredients/check', data, { params: new_params })
}

export function validateMaterial(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/ingredients/validate', data, { params: new_params })
}
